import i18n from '../../../../../../i18n';
import { LanguageStringMap } from '../../../../../../types/Common';

export interface ApiErrorObject {
  code: number;
  detail: LanguageStringMap;
  msg: string;
  rpc_code: number;
}

class WgApiError extends Error {
  code: number;
  detail: LanguageStringMap;
  msg: string;
  rpc_code: number;

  constructor(error: ApiErrorObject) {
    super(error.detail[i18n.language]);
    this.code = error.code;
    this.detail = error.detail;
    this.msg = error.msg;
    this.rpc_code = error.rpc_code;
  }
}

export default WgApiError;
